/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import Masonry from 'react-masonry-css'

const shoppingBasketBackgroundUrl = toAbsoluteUrl('/media/patterns/shopping-bg.png');
const hopScotchBackgroundUrl = toAbsoluteUrl('/media/patterns/hopskotch-bg.png');
const flashThePicturesBackgroundUrl = toAbsoluteUrl('/media/patterns/flashpicture-bg.png');
const hygieneRunBackgroundUrl = toAbsoluteUrl('/media/patterns/hygine-bg.png');

const breakpointColumnsObj = {
    default: 2,
    1100: 2,
    700: 1,
    500: 1
}

const GamesPage: FC = () => (
    <>
        <div className='row gy-0'>
            <h1 className='dashboard-hello'>
                Games
            </h1>
        </div>
        <Masonry
            breakpointCols={breakpointColumnsObj}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
        >
            <ShoppingBasket />
            <HopScotch />
            <FlashThePictures />
            <HygieneRun />
        </Masonry>
    </>
)

const GamesWrapper: FC = () => {
    return (
        <>
            <GamesPage />
        </>
    )
}

const ShoppingBasket = () => {
    return  (
        <div className="col-sm">
        <div className="card dashboard-card"
          style={{
            backgroundImage: "url(" + shoppingBasketBackgroundUrl + ")",
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
          }}
        >
        <div className="card-body dashboard-card-body">
            <br></br><br></br><br></br><br></br><br></br>
            <br></br><br></br><br></br><br></br><br></br>
            <br></br><br></br>
            <h5 className="card-title dashboard-card-title">Shopping Basket</h5>
            <h6 className="card-subtitle game-card-title">
                Let's have a little competition to see who picks the best nutrition. Shop away and fill your cart with a basket full of good health and happiness!
            </h6>
            <a href="/shopping-game" className="btn card-button dashboard-card-button">play</a>
          </div>
        </div>
      </div>
    )
}

const HopScotch = () => {
    return  (
        <div className="col-sm">
        <div className="card dashboard-card"
          style={{
            backgroundImage: "url(" + hopScotchBackgroundUrl + ")",
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
          }}
        >
        <div className="card-body dashboard-card-body">
            <br></br><br></br><br></br><br></br><br></br>
            <br></br><br></br><br></br><br></br><br></br>
            <br></br><br></br><br></br><br></br><br></br>
            <br></br><br></br><br></br><br></br>
            <h5 className="card-title dashboard-card-title">Hop Scotch</h5>
            <h6 className="card-subtitle game-card-title">
                Hop Hop Hop, Hop to the Op- To get to the top, pick the right op. Answer the questions right, and get an extra hop. Let's see how many extra hops you get!
            </h6>
            <a href="/hop-scotch" className="btn card-button dashboard-card-button">play</a>
          </div>
        </div>
      </div>
    )
}


const FlashThePictures = () => {
    return  (
        <div className="col-sm">
        <div className="card dashboard-card"
          style={{
            backgroundImage: "url(" + flashThePicturesBackgroundUrl + ")",
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
          }}
        >
        <div className="card-body dashboard-card-body">
            <br></br><br></br><br></br><br></br><br></br>
            <br></br><br></br><br></br><br></br><br></br>
            
            <h5 className="card-title dashboard-card-title">Flash The Pictures</h5>
            <h6 className="card-subtitle game-card-title">
                Let's have some fun story telling time where we show you some pictures and you write a little story about what you think is happening in the pretty picture!
            </h6>
            <a href="/flash-the-picture" className="btn card-button dashboard-card-button">play</a>
          </div>
        </div>
      </div>
    )
}


const  HygieneRun = () => {
    return  (
        <div className="col-sm">
        <div className="card dashboard-card"
          style={{
            backgroundImage: "url(" + hygieneRunBackgroundUrl + ")",
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
          }}
        >
        <div className="card-body dashboard-card-body">
            <br></br><br></br><br></br><br></br><br></br>
            <br></br><br></br><br></br><br></br><br></br>
            <br></br><br></br><br></br><br></br><br></br>
            <h5 className="card-title dashboard-card-title">Hygiene Run</h5>
            <h6 className="card-subtitle game-card-title">
                As you run through the field, we want you to collect the goodies that you should be using for your periods and jump over the ones that you should avoid and are bad!
            </h6>
            <a href="/hygiene-run" className="btn card-button dashboard-card-button">play</a>
          </div>
        </div>
      </div>
    )
}

export { GamesWrapper }
